module.exports = __webpack_public_path__ + "img/8.743b0ade.png";